<template>
  <a-card
    title="用户查询"
    size="small"
    :headStyle="{
      background: '#f3f3f3',
    }"
  >
    <a-form layout="inline" labelAlign="right" :labelCol="labelCol">
      <a-form-item label="积分平台会员ID">
        <a-input v-model:value="form.memberId"> </a-input>
      </a-form-item>
      <a-form-item label="积分名称" name="carrier">
        <a-select v-model:value="form.carrier" style="width:195px">
          <a-select-option
            v-for="(item, index) in scoreNameList"
            :value="item.value"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="证件号" name="idNumber">
        <a-input v-model:value="form.idNumber"></a-input>
      </a-form-item>
      <!-- <a-form-item label="兑换时间">
        <a-range-picker
          style="width: 195px"
          valueFormat="YYYY-MM-DD"
          format="YYYY-MM-DD"
          v-model:value="form.date"
        ></a-range-picker>
      </a-form-item> -->
    </a-form>
    <div style="display:flex;justify-content:center;">
      <a-form-item>
        <a-button class="mr" type="primary" @click="query"> 查询 </a-button>
      </a-form-item>

      <a-form-item>
        <a-button class="mr" @click="reset()">重置</a-button>
      </a-form-item>
      <a-form-item>
        <a-button class="mr" type="primary" @click="exports"> 导出 </a-button>
      </a-form-item>
    </div>
    <br />
    <a-table
      bordered
      :dataSource="list"
      :pagination="false"
      :columns="columns"
      style="word-break: break-all;overflow-y:scroll"
      :loading="loading"
      :rowKey="
        (record, index) => {
          return index;
        }
      "
      :row-selection="rowSelection"
    >
      <template #carrier="{text,record}">
        {{
          record.carrier === "CA"
            ? "国航"
            : record.carrier === "MU"
            ? "东航"
            : ""
        }}
      </template>
      <template #username="{text,record}">
        {{ compareUserName(record) }}
      </template>
      <template #gender="{text,record}">
        <!-- {{ record.idNumber.substr(-2, 1) % 2 === 0 ? "女" : "男" }} -->
        {{ record.gender == "F" ? "女" : "男" }}
      </template>
      <template #idType="{text,record}">
        {{ record.idType === "I" ? "身份证" : "护照" }}
      </template>
      <template #nation="{text,record}">
        {{ record.mailCountry === "CN" ? "中国" : "" }}
      </template>
    </a-table>
  </a-card>
  <df-pagination :model="pageObj"></df-pagination>
</template>

<script>
import { reactive, ref, provide } from "vue";
import orderApi from "@axios/order";
import { exportOut } from "@axios/exportOut";
export default {
  setup() {
    let form = reactive({
      memberId: "",
      //积分名称
      carrier: "",
      //证件号
      idNumber: "",
    });
    let loading = ref(false);
    let list = ref([]);
    //积分名称
    let scoreNameList = reactive([
      {
        value: "",
        name: "全部",
      },
      {
        value: "MU",
        name: "东航",
      },
      {
        value: "CA",
        name: "国航",
      },
       {
        value: "CZ",
        name: "南航",
      },
    ]);
    let query = () => {
      loading.value = true;
      let params = {
        state: activeKey.value == "0" ? null : activeKey.value,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
        // memberId: form.memberId,
      };
      if (form.memberId) {
        params.memberNo = form.memberId;
      }
      if (form.carrier) {
        params.carrier = form.carrier;
      }
      if (form.idNumber) {
        params.idNumber = form.idNumber;
      }
      orderApi.userScore(params).then((res) => {
        loading.value = false;
        list.value = res.data;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
      });
    };
    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });
    let activeKey = ref("0");
    const pageChange = (page) => {
      pageObj.value.page = page;
      query();
    };
    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      query();
    };
    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);
    query();
    //导出
    let exports = () => {
      let params = {
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };
      //积分平台订单号
      if (form.memberId) {
        params.memberId = form.memberId;
      }
      if (form.carrier) {
        params.carrier = form.carrier;
      }
      let fileName = "积分用户明细-";
      exportOut(
        params, // 导出请求参数
        "/app-admin/point/download/user", // 接口地址
        fileName // 导出文件名字
      );
    };
    //重置
    let reset = () => {
      form.memberId = "";
      form.carrier = "";
      form.name = "";
      form.idNumber = "";
      form.date = [];
      query();
    };
    let compareUserName = (record) => {
      if (
        record.cnSurname &&
        record.cnGivenName &&
        record.enSurname &&
        record.enGivenName
      ) {
        return (
          record.cnSurname +
          record.cnGivenName +
          "-" +
          record.enSurname +
          record.enGivenName
        );
      }
      if (record.cnSurname && record.cnGivenName) {
        return record.cnSurname + record.cnGivenName;
      }
      if (!record.cnSurname)
        return record.cnGivenName || record.cnGivenName || record.enSurname;
      if (!record.cnGivenName)
        return record.cnSurname || record.enSurname || record.enGivenName;
      if (!record.enSurname)
        return record.enGivenName || record.cnSurname || record.cnGivenName;
      if (!record.enGivenName)
        return record.enSurname || record.cnSurname || record.cnGivenName;
      if (record.cnSurname && record.cnGivenName) {
        return record.cnSurname + record.cnGivenName;
      }
      if (record.enSurname && record.enGivenName) {
        return record.enSurname + record.enGivenName;
      }
      if (
        record.cnSurname ||
        record.cnGivenName ||
        record.enSurname ||
        record.enGivenName
      ) {
        return (
          record.cnSurname +
          record.cnGivenName +
          "/" +
          record.enSurname +
          record.enGivenName
        );
      }
    };
    return {
      exports,
      compareUserName,
      reset,
      scoreNameList,
      loading,
      activeKey,
      onShowSizeChange,
      pageChange,
      pageObj,
      form,
      query,
      list,
      labelCol: {
        style: {
          width: "110px",
        },
      },
      columns: [
        {
          title: "积分平台会员ID",
          dataIndex: "memberNo",
          width: 150,
          align: "center",
        },
        {
          title: "积分名称",
          dataIndex: "carrier",
          width: 150,
          align: "center",
          slots: {
            customRender: "carrier",
          },
        },
        {
          title: "姓名",
          dataIndex: "scoreName",
          width: 150,
          align: "center",
          slots: { customRender: "username" },
        },
        {
          title: "性别",
          dataIndex: "scoreName",
          width: 150,
          align: "center",
          slots: { customRender: "gender" },
        },
        {
          title: "证件类型",
          dataIndex: "idType",
          key: "idType",
          width: 100,
          align: "center",
          slots: { customRender: "idType" },
        },
        {
          title: "证件号",
          dataIndex: "idNumber",
          key: "idNumber",
          width: 150,
          align: "center",
        },
        {
          title: "出生日期",
          dataIndex: "birthday",
          key: "birthday",
          width: 150,
          align: "center",
        },
        {
          title: "国籍",
          dataIndex: "nationality",
          key: "nationality",
          width: 150,
          align: "center",
          slots: {
            customRender: "nation",
          },
        },
        {
          title: "移动电话",
          dataIndex: "mobile",
          key: "mobile",
          width: 150,
          align: "center",
        },
        {
          title: "邮箱",
          dataIndex: "email",
          key: "email",
          width: 150,
          align: "center",
        },
        {
          title: "详细地址",
          dataIndex: "mailAddress",
          key: "mailAddress",
          width: 150,
          align: "center",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
/deep/ label {
  font-weight: normal;
}
.mr {
  margin-right: 10px;
}
// .ant-card-body {
//   overflow:hidden;
// }
</style>
